module.exports = __webpack_public_path__ + "static/media/andriodstudio.88ed160d.png";